
import { FieldArray } from 'react-final-form-arrays';
import { Field, useForm } from 'react-final-form';
import styles from './GstDetails.module.scss';
import OutlinedFormInput from '../../../Finance/components/OutlinedFormInput/OutlinedFormInput';
import TableUploadRow from '../../components/TableForm/TableUploadRow';
import { alignmentType, ApplicationContextType, UnderwritingFormStatus, UnderwritingSteps } from '../../../../interfaces/interfaces';
import { TableForm } from '../../components/TableForm/TableForm';
import GstAccount from './GstAccount';
import MeritoButton from '../../../../components/common/MeritoButtons/MeritoButtons';
import { RiAddFill as AddIcon } from 'react-icons/ri'
import { getInitialGstDetails, gstDetailInitialState } from '../../context/UnderwritingFormContext';
import { useAppSelector } from '../../../../redux/reduxHooks';
import { useEffect } from 'react';


const orderedList = [
  <>Visit the GST portal: <a href="https://services.gst.gov.in/services/login" target='_blank'>https://services.gst.gov.in/services/login</a></>,
  <>Navigate to <b>My Profile</b> {`>`} <b>Manage API Access.</b></>,
  <>Choose <b>Yes</b> under <b>Enable API Request.</b></>,
  <>Under <b>Duration</b>, choose <b>30 days.</b></>,
  <>Click on Proceed.</>
]

type Props = {
  formCompleteStatus: {
    [x: string]: UnderwritingFormStatus
  },
  newUploadedDocIds: number[],
  setNewUploadedDocIds: React.Dispatch<React.SetStateAction<number[]>>;
  deleteDocIds: number[],
  setDeleteDocIds: React.Dispatch<React.SetStateAction<number[]>>;
  gstApiErrors?: any;
  setGstApiErrors: React.Dispatch<React.SetStateAction<any>>;
  formContext?: any;
  formType: ApplicationContextType
}



const GstDetails = ({ formCompleteStatus, newUploadedDocIds, deleteDocIds, setDeleteDocIds, setNewUploadedDocIds, setGstApiErrors, gstApiErrors, formContext, formType }: Props) => {



  return (
    <div className={styles.sectionFieldsContainer}>
      <div className={styles.bannerContainer}>
        <div className={styles.topText}>
          ⚠️ Enable API access for each GSTIN before proceeding:
        </div>
        <ol>
          {orderedList.map((item, index) => {
            return (
              <li key={index} className={styles.listItem}>
                {item}
              </li>
            )
          }
          )}
        </ol>
      </div>
      <FieldArray name='gstStatements'>
        {({ fields }) => (
          <>
            {fields.map((name, index) => {
              return (
                <GstAccount
                  fieldName={name}
                  gstAccountIndex={index}
                  formCompleteStatus={formCompleteStatus}
                  deleteDocIds={deleteDocIds}
                  setDeleteDocIds={setDeleteDocIds}
                  newUploadedDocIds={newUploadedDocIds}
                  setNewUploadedDocIds={setNewUploadedDocIds}
                  statementLength={fields.length}
                  gstApiErrors={gstApiErrors}
                  setGstApiErrors={setGstApiErrors}
                  formContext={formContext}
                  formType={formType}
                />
              )
            })}

            <div className={styles.bottomBtnContainer}>
              <MeritoButton
                size='md2'
                type='secondary-1'
                icon={<AddIcon />}
                onClick={() => {
                  fields.push(gstDetailInitialState)
                }}
                btnText={`Add GST Account ${fields.length + 1}`}
              />
            </div>
          </>
        )}
      </FieldArray>
    </div>
  );
}

export default GstDetails;